export enum DialogType {
  MANUAL_SUBMISSION = 0,
}
